/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
import React from "react";
import * as S from "./styles";
import Header from "./Header";
import { termoUsoJson } from "./termoUsoJson";

const TermosDeUso: React.FC = () => {
  return (
    <S.Container>
      <Header />
      <S.PageWrapper>
        <S.Content>
          <S.Titulo>{termoUsoJson.titulo}</S.Titulo>
          <S.Item>{termoUsoJson.descricao}</S.Item>
          {[
            termoUsoJson.termo_e_condicoes_de_uso,
            termoUsoJson.usos_permitidos,
            termoUsoJson.do_cadastro_na_plataforma,
            termoUsoJson.do_uso_da_conta_login_senha,
            termoUsoJson.responsabilidades,
            termoUsoJson.da_confidencialidade,
            termoUsoJson.da_propriedade_intelectual,
            termoUsoJson.da_politica_de_privacidade,
            termoUsoJson.das_falhas_na_plataforma,
            termoUsoJson.prazo_de_vigencia,
            termoUsoJson.descadastro_da_plataforma,
          ].map((section, index) => (
            <div key={`section-${section.titulo}-${index}`}>
              <S.Subtitulo>{section.titulo}</S.Subtitulo>

              {/* Renderiza itens numerados */}
              {section.itens.numerados &&
                Object.entries(section.itens.numerados).map(([key, item]) => (
                  <S.ItemWithIndent key={key} level={item.level}>
                    <strong>{key}</strong> {item.texto}
                  </S.ItemWithIndent>
                ))}

              {/* Renderiza itens não numerados */}
              {section.itens.naoNumerados &&
                section.itens.naoNumerados.map((item, idx) => (
                  <S.ItemWithIndent
                    key={`item-${item.texto.substring(0, 20)}-${idx}`}
                    level={item.level}
                  >
                    {item.texto}
                  </S.ItemWithIndent>
                ))}
            </div>
          ))}
          <S.Subtitulo>{termoUsoJson.conclusao}</S.Subtitulo>
        </S.Content>
      </S.PageWrapper>
    </S.Container>
  );
};

export default TermosDeUso;
